import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin, Tooltip } from 'antd';
import { Block } from 'components/block';
import { useBlockEditMode } from 'components/block/utils';
import { InfoCircleIcon } from 'components/icons';
import { useEmployee } from 'hooks';
import { usePlatformDictionary } from 'hooks/use-platform-dictionary';
import { PlatformsForm, PlatformsFormProps } from 'user/forms/platforms-form';

export const PlatformsBlock: FC = () => {
  const { t } = useTranslation();
  const { loading: employeeLoading } = useEmployee();
  const { loading: platformDictionaryLoading } = usePlatformDictionary();

  const {
    buttons: platformsBlockButtons,
    isEditMode: editMode,
    setIsEditMode: setEditMode,
    formName,
    form,
  } = useBlockEditMode({
    formName: 'platforms-form',
  });

  const infoCircle = (
    <Tooltip title="Platforms are the systems which provided a variety of solutions for optimizing the company's business processes.">
      <InfoCircleIcon />
    </Tooltip>
  );

  if (employeeLoading || platformDictionaryLoading) {
    return (
      <Block
        title={t('Platforms')}
        subTitle={infoCircle}
        extra={platformsBlockButtons}
      >
        <Spin />
      </Block>
    );
  }

  const platformsFormProps: PlatformsFormProps = {
    editMode,
    form,
    formName,
    setEditMode,
  };

  return (
    <Block
      title={t('Platforms')}
      subTitle={infoCircle}
      extra={platformsBlockButtons}
    >
      <PlatformsForm {...platformsFormProps} />
    </Block>
  );
};
